var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9138 3.91232C11.1416 3.68451 11.1416 3.31516 10.9138 3.08736C10.686 2.85955 10.3166 2.85955 10.0888 3.08736L7.0013 6.17488L3.91378 3.08736C3.68598 2.85955 3.31663 2.85955 3.08882 3.08736C2.86102 3.31516 2.86102 3.68451 3.08882 3.91232L6.17634 6.99984L3.08882 10.0874C2.86102 10.3152 2.86102 10.6845 3.08882 10.9123C3.31663 11.1401 3.68598 11.1401 3.91378 10.9123L7.0013 7.82479L10.0888 10.9123C10.3166 11.1401 10.686 11.1401 10.9138 10.9123C11.1416 10.6845 11.1416 10.3152 10.9138 10.0874L7.82626 6.99984L10.9138 3.91232Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.516230cc6999a200b2a0777b08e97933.svg";
export { ForwardRef as ReactComponent };